// extracted by mini-css-extract-plugin
module.exports = {"container_class":"sidePanel_container_class__1WShm","render_dashboard_menu":"sidePanel_render_dashboard_menu__36qnA"};